import { ReactEventHandler } from 'react';
import { PlacesType, Tooltip as ReactTooltip, ITooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import styled from 'styled-components';

export const IconStyled = styled.i.attrs(({ icon }: { icon: string }) => ({
  className: icon,
}))<{ fontSize?: string }>` ${({ theme, fontSize }) => `
  color: ${theme.colours.neutral[4]};  
  font-size: ${fontSize || theme.fontSize[3]};
  margin: ${theme.padding[1]};
`}`;

const StyledTooltip = styled(ReactTooltip)<{ isLarge?: boolean, widthOverload?: number }>`
  max-width: ${({ widthOverload = 300 }) => `${widthOverload}px`};
  font-size:  ${({ theme }) => theme.fontSize[1]} !important;
  font-weight: ${({ theme }) => theme.fontWeight.normal};
  line-height: ${({ theme }) => theme.fontSize[3]};
  font-family: 'Open Sans', sans-serif;
  white-space: normal;
  word-wrap: break-word;
  border-radius:  ${({ theme }) => theme.borderRadius[2]};
  opacity: 1;
  background: ${({ theme }) => theme.colours.neutral[2]};
  padding: ${({ isLarge, theme }) => {
    if (isLarge) {
      return `${theme.padding[3]}`;
    }
    return `${theme.padding[2]} ${theme.padding[3]}`;
  }};
`;

interface ToolTipProps extends ITooltip {
  id: string,
  place?: PlacesType;
  content?: string;
  html?: string;
  isLarge?: boolean;
  widthOverload?: number;
}

interface ToolTipIconProps extends ToolTipProps {
  className?: string,
  fontSize?: string,
  onClick?: ReactEventHandler,
}

export function Tooltip({
  id,
  place = 'top',
  content = '',
  html,
  widthOverload,
  isLarge = false,
  ...rest
}: ToolTipProps) {
  return (
    <StyledTooltip
      place={place}
      anchorId={id}
      content={content}
      html={html}
      isLarge={isLarge}
      widthOverload={widthOverload}
      {...rest}
    />
  );
}

export function TooltipIcon({
  id,
  place = 'top',
  content = '',
  html = undefined,
  className = 'mi-circle-help',
  fontSize = undefined,
  onClick = undefined,
  isLarge = false,
  widthOverload,
  ...rest
}: ToolTipIconProps) {
  return (
    <>
      <IconStyled
        className={className}
        fontSize={fontSize}
        id={id}
        onClick={onClick}
      />
      <Tooltip
        place={place}
        id={id}
        content={content}
        html={html}
        isLarge={isLarge}
        widthOverload={widthOverload}
        {...rest}
      />
    </>
  );
}
